<template>
  <Popup 
    :ref="(el) => popup = el"
    :title="$t('fraudex.leave_feedback')"
    class="popup__md"
    @onClose="hide"
  >
    <form>
      <div class="popup__content" v-if="requisite">
        <div class="requisites__block mb-3">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t('labels.requisites') }}
          </div>
          <div class="requisites__content">
            <input 
              type="text" 
              class="form-control" 
              :value="requisite" 
              readonly
            >
          </div>
        </div>

        <div class="requisites__block mb-3">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t('fraudex.comment') }}
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="text" form="fraudexFeedback">
              <textarea 
                class="form-control" 
                rows="4" 
                v-model="feedbackText"
                :class="parentProps.class"
                :placeholder="$t('fraudex.comment_placeholder')"
              ></textarea>
            </FormInputWrapper>
          </div>
        </div>
      </div>
    </form>
    
    <div class="popup__controls">
      <button 
        type="button" 
        @click="hide" 
        class="btn popup__close"
      >
        <span class="text-capitalize-first">{{ $t('button.cancel') }}</span>
      </button>
      <LoaderButton 
        :on-click="handleSubmit" 
        :disabled="!feedbackText || feedbackText.trim().length === 0"
        class="btn btn--accept"
      >
        <i class="fa fa-paper-plane me-2"></i>
        <span class="text-capitalize-first">{{ $t('button.send') }}</span>
      </LoaderButton>
    </div>
  </Popup>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import Popup from '@/apps/public/components/Popup.vue';
import { $t, helper } from '@/service/CommonHelper';
import LoaderButton from '@/apps/public/components/LoaderButton.vue';
import FormInputWrapper from '@/components/FormInputWrapper.vue';

export default defineComponent({
  name: 'FraudexFeedbackPopup',
  methods: { $t: $t },
  components: {
    Popup,
    LoaderButton,
    FormInputWrapper,
  },
  props: {
    requisite: {
      type: String,
      default: '',
    },
  },
  emits: ['submit'],
  setup(props, { emit }) {
    const popup = ref<InstanceType<typeof Popup> | null>(null);
    const feedbackText = ref('');

    const show = () => {
      feedbackText.value = '';
      helper.clearErrors('fraudexFeedback');
      popup.value?.show();
    };

    const hide = () => {
      popup.value?.hide();
    };

    const handleSubmit = async () => {
      if (!feedbackText.value || feedbackText.value.trim().length === 0) {
        return;
      }
      emit('submit', feedbackText.value);
      hide();
    };

    return {
      helper,
      feedbackText,
      popup,
      show,
      hide,
      handleSubmit,
    };
  },
});
</script>
